import { z } from "zod";

export type Job = {
  id: string;
  createdTime: string;
  fields: {
    Job: string;
    "Job Description": string;
  };
};

export const ContactFormSchema = z.object({
  Name: z.string().min(2, "Full name is required"),
  Email: z.email("Invalid e-mail address"),
  "I am": z.object(
    {
      value: z.string().min(1, "Please select an option"),
      label: z.string().min(1, "Please select an option"),
    },
    { message: "Please select an option" },
  ),
  Notes: z.string().min(10, "Message is too short"),
});

export type ContactFormInputs = z.infer<typeof ContactFormSchema>;

export type Testimonial = {
  id: string;
  createdTime: string;
  fields: {
    Name: string;
    Slug: string;
    Quote: string;
    Position: string;
    Body: string;
    Photo: string;
  };
};
